import { render, staticRenderFns } from "./product-tip-slider.vue?vue&type=template&id=6cbf5753&"
import script from "./product-tip-slider.vue?vue&type=script&lang=js&"
export * from "./product-tip-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports